import type { JSX } from 'react';

import { MoonIcon, SunIcon } from '@/components/ui/icons';
import { useTheme } from '@/theme/useTheme';

export function ThemeToggle(): JSX.Element {
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${nextTheme} theme`}
      title={`Switch to ${nextTheme} theme`}
      className="inline-flex size-11 items-center justify-center rounded-md border border-line bg-surface text-muted transition-colors duration-150 hover:bg-surface-muted hover:text-text"
    >
      {theme === 'dark' ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
